import PackageMixin from './PackageMixin'

export default {
    mixins: [
        PackageMixin
    ]
}